import { Link } from "react-router-dom";
import React, { useState } from 'react';

const links = [
    {
        name: 'Home',
        href: '/'
    },
    {
        name: 'About us',
        href: '/about/'
    },
    {
        name: 'Practices',
        href: '/practices/'
    },
    {
        name: 'Careers',
        href: '/careers/'
    },
    {
        name: 'Feedback',
        href: '/feedback/',
    },
    {
        name: 'Contact us',
        href: '/contact/'
    },
]

export default function BottomFooter() {
    const [hovered, setHovered] = useState("");

    const hoveredLink = (name) => {
        setHovered(name);
    }

    return(
        <div className="bg-white p-2 flex justify-center">
            <div className="flex gap-11">
                <small className="font-light">&copy; 2023 Quilaton Law Office. All Rights Reserved.</small>
                <div className="flex">
                    <div className="flex text-black">
                        {links.map((link) => {
                            return (
                                <div className="flex gap-3">
                                    <small className="text-black">
                                        <Link
                                            key={link.name}
                                            to={link.href}
                                            onMouseEnter={() => hoveredLink(link.name)}
                                            onMouseLeave={() => hoveredLink("")}
                                        >
                                            {link.name}
                                        </Link>
                                    </small>
                                    <div className={`border-b border-b-black transition-all duration-300 ease-in-out overflow-hidden ${ hovered === link.name ? 'w-full' : 'w-0'}`}></div>                                
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}